import React from "react";
import { modalProps } from "../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactDOM from "react-dom";

const Modal : React.FC<modalProps> = ({onClose, children})=>{
        return ReactDOM.createPortal(
            <div className='modal-container'>
                <div className='modal'>
                    <div className='modal-header'>
                        <button type="button" className='ms-auto text-red-500' onClick={onClose}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <div className='modal-body'>
                        {children}
                    </div>
                </div>
            </div>,
            document.body
        );
}

export default Modal;